import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import { withStyles } from '@material-ui/core/styles';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from "@material-ui/core/Button"
import TextField from '@material-ui/core/TextField';
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import DialogContentText from '@material-ui/core/DialogContentText';
import LinearProgress from '@material-ui/core/LinearProgress';

/*Events and Styling */
const styles = {
  appBar: {
    position: 'relative',
  },
  flex: {
    flex: 1,
  }, 
  loadButton:{
    marginRigth:"3", 
    float:"left"
  }, 
  fileNameField:{
    width:"100%"
  }, 
  loadingText:{
    fontSize:"0.8em", 
    color:"grey"
  }, 
  errorText:{
    fontSize:"0.8em",
    color:"red"
  }, 
  successText:{
    fontSize:"0.8em",
    color:"green"
  }
};

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

export class Fileupload extends Component {
  static propTypes = {
    fileupload: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  constructor(props) {
    super(props)
    this.state = {
       titulo: props.titulo? props.titulo: "Upload File (.csv/.xlsx)",  
       tipoCarga:props.tipoCarga? props.tipoCarga: ".csv,.xlsx", 
       nombreArchivo:"", 
       archivo:{}, 
       fileSelected:false, 
       loadSuccess:false,
       phase1:false,
       type:1,
       message:"Note: The column name to load is 'deliverable', other column names will be ignored."
    }
  }
  
  componentDidUpdate(){
    if(this.state.phase1&&!this.props.fileupload.loadingFile&& !this.props.fileupload.uploadFileError ){
      this.setState({
       phase1:false,
       loadSuccess:true
      })
      setTimeout(() => this.handleCloseDialog(), 1500);
    }
  }
  componentWillReceiveProps(nextProps){
    if(nextProps.type===2){
      // for Currency catalog
      this.setState({
        type:nextProps.type,
        message:"Note: the column names to load are 'name' and 'symbol', other column names will be ignored."
      })
    }else if(nextProps.type===3||nextProps.type===4){
      this.setState({
        type:nextProps.type,
        message:"Note: the column name to load is 'name', other column names will be ignored."
      })
    }
  }

  handleFileUpload = (input) => {
    let archivo = input.target.files[0]
    this.setState({
      nombreArchivo:archivo.name,
      archivo:archivo, 
      fileSelected:true,
    })
  }
  handleCloseDialog=()=>{
    this.setState({
      nombreArchivo:"",
      archivo:{}, 
      fileSelected:false, 
      controlLoadingCatalago:false,
      loadSuccess:false,
    })
    this.props.actions.setNullLoadingError();
    this.props.closeDialog();
    this.props.updateAfterCsv()
  }
  saveFile=()=>{
    this.setState({
      phase1:true,
    })
    this.props.actions.setLoading()
    this.props.actions.uploadFile(this.state.archivo,this.state.type)
    this.setState({fileSelected:false})
  }
  render() {
    const { classes } = this.props;
    return (
      <Dialog
          open={this.props.openDialog}
          onClose={this.handleCloseDialog}
          TransitionComponent={Transition}
          fullWidth
        >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton color="inherit" onClick={this.handleCloseDialog} aria-label="Close">
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" color="inherit" className={classes.flex}>
              Close 
            </Typography>
          </Toolbar>
        </AppBar>
        <DialogTitle id="form-dialog-title">{this.state.titulo}</DialogTitle>
        <DialogContent>
        <DialogContentText id="alert-dialog-description">
            {this.state.message}
          </DialogContentText>
        <TextField
          id="standard-name"
          value={this.state.nombreArchivo}
          margin="normal"
          className={classes.fileNameField}
        />  
          {this.props.fileupload.loadingFile? 
            (
            <div>
              <div className={classes.loadingText}>Loading...</div>
              <LinearProgress color="secondary" />
            </div>
            ):""
          }
          {this.props.fileupload.uploadFileError? 
            (
            <div>
              <div className={classes.errorText}>Something went wrong.</div>
            </div>
            ):""
          }
          {this.state.loadSuccess? 
            (
            <div>
              <div className={classes.successText}>CSV Loaded!</div>
            </div>
            ):""
          }
          <br />
          <input
            accept={this.state.tipoCarga}
            style={{display:"none"}}
            id="contained-button-file"
            multiple
            type="file"
            onChange={this.handleFileUpload}
          />
          <label htmlFor="contained-button-file">
            <Button variant="contained" component="span"  className={classes.loadButton}
            disabled={this.props.fileupload.uploadFileError}
            >
              Select file
            </Button>
          </label>
          <div className={classes.saveButton}> 
            <Button variant="contained" color="primary" style={{marginLeft:"5px"}} 
            disabled={!this.state.fileSelected || this.props.fileupload.loadingFile ||this.props.fileupload.uploadFileError} 
            onClick={this.saveFile}
            >
              Save
            </Button>
          </div>          
        </DialogContent>
      </Dialog>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    fileupload: state.fileupload,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Fileupload));
    


// WEBPACK FOOTER //
// ./src/features/fileupload/Fileupload.js